export enum MatchmakingMatchTypes {
    WeeklyRotatingFunGame,
    RankedClassic4P,
    UnrankedClassic4P,
    RankedClassic56P,
    UnrankedClassic56P,
    RankedSeafarers4P,
    UnrankedSeafareres4P,
    RankedSeafarers56P,
    UnrankedSeafareres56P,
    RankedCitiesAndKnights4P,
    UnrankedCitiesAndKnights4P,
    RankedCitiesAndKnights56P,
    UnrankedCitiesAndKnights56P,
    UnrankedClassic1v1,
    UnrankedClassicFreeMapRotation, // Jan 30, 2022. Jeff: Removed because it was very unpopular. Do not delete enum.
    RankedClassic1v1,
}
